export const base_inquiries = [{
	type: 1,
	title: 'شاهکار',
	desc: 'استعلام مطابقت مالکیت خط و کد ملی',
	statusIcon: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'mdi-check' : 'mdi-close' : 'mdi-history',
	icon: 'mdi-bank',
	active: true,
	badgeColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'green' : 'red' : 'red',
	iconColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'white' : 'red' : 'red',
	systemType: 15,
	price: 0
}, {
	type: 2,
	title: 'شاهکار تکمیلی',
	desc: 'استعلام مطابقت مالکیت خط و کد ملی و تاریخ تولد و شماره شبا',
	statusIcon: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'mdi-check' : 'mdi-close' : 'mdi-history',
	icon: 'mdi-bank',
	active: true,
	badgeColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'green' : 'red' : 'red',
	iconColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'white' : 'red' : 'red',
	systemType: 16,
	price: 0
}, {
	type: 3,
	title: 'استعلام ثنا',
	desc: 'استعلام وضعیت داشتن یا نداشتن شماره ثنا',
	statusIcon: (items) => items?.length ? items[0].parsedResult?.hasSana ? 'mdi-check' : 'mdi-close' : 'mdi-history',
	icon: 'mdi-scale-balance',
	active: true,
	badgeColor: (items) => items?.length ? items[0].parsedResult?.hasSana ? 'green' : 'red' : 'red',
	iconColor: (items) => items?.length ? items[0].parsedResult?.hasSana ? 'white' : 'red' : 'red',
	systemType: 17,
	price: 0
}, {
	type: 4,
	title: 'استعلام چک برگشتی',
	desc: 'استعلام تعداد چک برگشتی',
	statusIcon: (items) => !items?.length ? 'mdi-history' : items[0].parsedResult?.count > 0 ? 'mdi-close' : 'mdi-check',
	icon: 'mdi-card-account-details-outline',
	active: true,
	badgeColor: (items) => !items?.length ? 'red' : items[0].parsedResult?.count > 0 ? 'red' : 'green',
	iconColor: (items) => !items?.length ? 'white' : items[0].parsedResult?.count > 0 ? 'white' : 'white',
	systemType: 18,
	price: 0
}, {
	type: 5,
	title: 'مشخصات هویتی',
	desc: 'استعلام مشخصات هویتی بر اساس کد ملی',
	statusIcon: (items) => items?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-star-check-outline',
	active: true,
	badgeColor: (items) => items?.length ? 'green' : 'red',
	iconColor: (items) => items?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 6,
	title: 'کدپستی و آدرس',
	desc: 'استعلام آدرس بر اساس کدپستی از اداره پست',
	statusIcon: (items) => items?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items?.length ? 'green' : 'red',
	iconColor: (items) => items?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 7,
	title: 'پلاک های فعال خودرو',
	desc: 'استعلام پلاک های فعال شخص بر اساس کدملی و شماره موبایل',
	statusIcon: (items) => items.length && items[0].parsedResult?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items.length && items[0].parsedResult?.length ? 'green' : 'red',
	iconColor: (items) => items.length && items[0].parsedResult?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 8,
	title: 'نام دارنده شبا',
	desc: 'با این سرویس می توانید نام شخص و نام بانک و وضعیت فعال بودن شبا بانکی را استعلام نمایید',
	statusIcon: (items) => items.length && items[0].parsedResult?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items.length && items[0].parsedResult?.length ? 'green' : 'red',
	iconColor: (items) => items.length && items[0].parsedResult?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 9,
	title: 'مطابقت کدملی و کارت بانکی',
	desc: 'بررسی تطبیق تعلق شماره کارت با کدملی',
	statusIcon: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'mdi-check' : 'mdi-close' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'green' : 'red' : 'red',
	iconColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'white' : 'red' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 10,
	title: 'رنگ چک صیادی',
	desc: 'استعلام رنگ چک صیادی جهت اطلاع از اعتبار مالی صادر کننده',
	statusIcon: (items) => items.length && items[0].parsedResult?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items.length && items[0].parsedResult?.length ? 'green' : 'red',
	iconColor: (items) => items.length && items[0].parsedResult?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 11,
	title: 'تسهیلات فعال بانکی',
	desc: 'اطلاع از تسهیلات و وام‌های فعال و مانده بدهی و تسهیلات سررسید گذشته مشتری',
	statusIcon: (items) => items.length && items[0].parsedResult?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items.length && items[0].parsedResult?.length ? 'green' : 'red',
	iconColor: (items) => items.length && items[0].parsedResult?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 12,
	title: 'خدمت سربازی',
	desc: 'اطلاع از وضعیت نظام وظیفه',
	statusIcon: (items) => items?.length ? items[0].parsedResult?.qualified ? 'mdi-check' : 'mdi-close' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items?.length ? items[0].parsedResult?.qualified ? 'green' : 'red' : 'red',
	iconColor: (items) => items?.length ? items[0].parsedResult?.qualified ? 'green' : 'red' : 'red',
	systemType: 19,
	price: 0
}, {
	type: 13,
	title: 'مشخصات چک صیادی',
	desc: 'استعلام از اطلاعات کامل چک',
	statusIcon: (items) => items.length && items[0].parsedResult?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items.length && items[0].parsedResult?.length ? 'green' : 'red',
	iconColor: (items) => items.length && items[0].parsedResult?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 14,
	title: 'مشخصات کارت بانکی',
	desc: 'با این سرویس می توانید نام شخص و شماره حساب و شماره شبا متعلق به کارت را استعلام نمایید',
	statusIcon: (items) => items.length && items[0].parsedResult?.length ? 'mdi-check' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items.length && items[0].parsedResult?.length ? 'green' : 'red',
	iconColor: (items) => items.length && items[0].parsedResult?.length ? 'white' : 'red',
	systemType: 0,
	price: 0
}, {
	type: 15,
	title: 'مطابقت کدملی و شبا',
	desc: 'بررسی تطبیق تعلق شماره شبا با کدملی',
	statusIcon: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'mdi-check' : 'mdi-close' : 'mdi-history',
	icon: 'mdi-file-document-outline',
	active: true,
	badgeColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'green' : 'red' : 'red',
	iconColor: (items) => items?.length ? items[0].parsedResult?.isMatch ? 'white' : 'red' : 'red',
	systemType: 0,
	price: 0
},
]
